<button [disabled]="disabled" [class.block]="block">
  <yoo-icon *ngIf="iconLeft" [icon]="iconLeft" [size]="iconSize" [animation]="iconAnimation"></yoo-icon>
  <span>
    <ng-content></ng-content>
  </span>
  <yoo-icon *ngIf="iconRight" [icon]="iconRight" [size]="iconSize" [animation]="iconAnimation"></yoo-icon>
</button>
